import React from 'react'

export const BkFlowSelect = ({ input, name, label, size, options, required, meta: { touched, error } }) => {
  let selectOptions = []

  for (let option in options) {
    selectOptions.push(
      <option
        key={ options[option] }
        value={ options[option] }
      >
        { options[option] }
      </option>
    )
  }

  return (
    <div className={touched && error ? 'u-form-col u-form-col--error u-form-col--' + size : 'u-form-col u-form-col--' + size}>
      <label id={ input.name + 'Label' } className="u-form-label" htmlFor={ input.name }>
        { required && '*' }
        { label }
      </label>

      <select
        { ...input }
        className='u-form-select'
        onBlur={ () => input.onBlur() }
        aria-labelledby={ input.name + 'Label' }
        required={required}
        aria-required={required ? true : false}
      >
        <option value='' disabled></option>
        { selectOptions }
      </select>

      { touched && ((error && <p className="u-font-error" aria-live="assertive">{error}</p>)) }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/forms/elements/BkFlowSelect.js